<template>
  <div class="home">
    <header-part></header-part>
    <whywe-part></whywe-part>
    <marvel-part></marvel-part>
    <product-home-part></product-home-part>
    <produce-part></produce-part>
    <comment-part></comment-part>
  </div>
</template>

<script>
import headerPart from "../Header.vue";
import whyWe from "../WhyWe.vue";
import marvel from "../Marvel.vue";
import produce from "../Produce.vue";
import product from "../ProductHome.vue";
import comment from "../Comment.vue";

export default {
  components: {
    headerPart,
    whywePart: whyWe,
    marvelPart: marvel,
    producePart:produce,
    productHomePart:product,
    commentPart:comment,
  },
};
</script>

<style></style>
